var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipateImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 11.25C15.9375 10.7322 15.5178 10.3125 15 10.3125C14.4822 10.3125 14.0625 10.7322 14.0625 11.25V14.0625H11.25C10.7322 14.0625 10.3125 14.4822 10.3125 15C10.3125 15.5178 10.7322 15.9375 11.25 15.9375H14.0625V18.75C14.0625 19.2678 14.4822 19.6875 15 19.6875C15.5178 19.6875 15.9375 19.2678 15.9375 18.75V15.9375H18.75C19.2678 15.9375 19.6875 15.5178 19.6875 15C19.6875 14.4822 19.2678 14.0625 18.75 14.0625H15.9375V11.25Z",
    fill: "#72D49B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75C3.75 1.67893 5.42893 0 7.5 0H22.5C24.5711 0 26.25 1.67893 26.25 3.75V26.25C26.25 28.3211 24.5711 30 22.5 30H7.5C5.42893 30 3.75 28.3211 3.75 26.25V3.75ZM22.5 1.875H7.5C6.46447 1.875 5.625 2.71447 5.625 3.75V26.25C5.625 27.2855 6.46447 28.125 7.5 28.125H22.5C23.5355 28.125 24.375 27.2855 24.375 26.25V3.75C24.375 2.71447 23.5355 1.875 22.5 1.875Z",
    fill: "#72D49B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipateImg);
export default __webpack_public_path__ + "static/media/ParticipateImg.45c6ea7e07f84c43de1e0384c78617bf.svg";
export { ForwardRef as ReactComponent };